module.exports = __webpack_public_path__ + "static/media/mint-water.a1be94dd.png";